import { makeStyles, Typography } from "@material-ui/core";
import { InfoBox } from "../../../../components/boxes/InfoBox";
import { Box } from "../Box";
import { GroupButton } from "../GroupButton";
import { Header } from "../Header";

const useStyles = makeStyles((theme) => ({
  chartTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(3.5),
  },
}));

export const InefficientAppliance = ({ building, onClose }) => {
  const classes = useStyles();

  return (
    <Box>
      <Header
        title="Inefficient appliance"
        building={building}
        onClose={onClose}
      />

      <InfoBox color="#FFE6E6">
        <Typography variant="h4">Inefficiency of the HVAC</Typography>
      </InfoBox>

      <Typography className={classes.chartTitle}>
        Consumption over 2021
      </Typography>

      <GroupButton
        buttons={[
          { text: "SHARE" },
          { text: "VIEW REPORT" },
          { text: "EXPORT SAME TYPE ALERTS" },
        ]}
      />
    </Box>
  );
};
